import { observer } from 'mobx-react';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useServiceRouter } from '@common/components/ServiceRouter';
import { checkRole } from '@common/components/RBAC';
import store from 'store';

import ProfileInfoBlockListBlock from './Block';
import ProfileItem from './Item';
import StyledInfoBlockList from './styled';

function InfoBlockList() {
	const { i18n, t } = useTranslation();
	const { checkService } = useServiceRouter();

	const languageLabel = useMemo(() => {
		const languageMap: Record<string, string> = {
			en: t('profile.english'),
			uk: t('profile.ukrainian'),
		};
		return languageMap[i18n.language];
	}, [i18n.language]);

	const location = store.profile.locations?.[0]?.name;
	const group = store.profile.student?.groups?.[0]?.name;

	const { studentParents } = store.profile;

	const informationList = useMemo(
		() => [
			{ label: t('profile.location'), value: location },
			{ label: t('profile.class'), value: group },
			{ label: t('profile.language'), value: languageLabel },
		],
		[location, group, languageLabel],
	);

	return (
		<StyledInfoBlockList>
			<ProfileInfoBlockListBlock title={t('profile.information')}>
				{informationList.map((item, index) => {
					if (!item.value) return null;

					return <ProfileItem key={index} label={item.label} value={item.value} />;
				})}
			</ProfileInfoBlockListBlock>
			{checkService('academy') && !!store.studentPrograms?.length && (
				<ProfileInfoBlockListBlock title="My courses">
					{store.studentPrograms.map((studentProgram, index) => {
						if (!studentProgram?.program_name) return null;

						return (
							<ProfileItem
								key={index}
								label={studentProgram?.program_name}
								value={studentProgram?.scheduleDuration}
							/>
						);
					})}
				</ProfileInfoBlockListBlock>
			)}
			{!checkService('learningCenter') && !checkRole('Parent') && (
				<ProfileInfoBlockListBlock title={t('profile.myParents')}>
					{studentParents.map((parent, index) => {
						if (!parent.fullName) return null;

						return (
							<ProfileItem key={index} value={parent.fullName} avatarSrc={parent.avatar_url} />
						);
					})}
				</ProfileInfoBlockListBlock>
			)}
		</StyledInfoBlockList>
	);
}

export default observer(InfoBlockList);
